import React from "react";
import "./header-top.scss";

import semaLogo from '../../../assets/icons/sema-logo-128.png';
import semaLogoMedium from '../../../assets/icons/sema-logo-96.png';
import semaLogoMini from '../../../assets/icons/sema-logo-64.png';
import muhruSerif from '../../../assets/icons/muhru-serif-128.png';
import muhruSerifMedium from '../../../assets/icons/muhru-serif-96.png';
import muhruSerifMini from '../../../assets/icons/muhru-serif-64.png';
import { Link } from "react-router-dom";

interface HeaderTopProps {

}
interface HeaderTopState {
    Change: boolean;
}

class HeaderTop extends React.Component<HeaderTopProps, HeaderTopState>{
    constructor(props: any) {
        super(props);
        this.state = {
            Change: true
        };
    }
    render() {
        return (
            <div className="header-top">
                <div className="header-top__content">
                    <Link to="/">
                        <div className="header-top-img sema">
                            <img
                                srcSet={`${semaLogoMini} 64w,${semaLogoMedium} 96w, ${semaLogo} 128w`}
                                sizes={"(max-width: 576px) 64px,(max-width: 768px) 96px, 128px"}
                                src={semaLogo} alt="Semazen"
                            />
                        </div>
                    </Link>
                    <div className="header-top-title">
                        <h1>
                            <div>HZ. MEVLANA'NIN KURMUŞ OLDUĞU</div>
                            <div>ULUSLARARASI DEVAM EDEN</div>
                            <div>SEMA OKULU</div>
                        </h1>
                    </div>
                    <div className="header-top-img muhur">
                        <img
                            srcSet={`${muhruSerifMini} 64w,${muhruSerifMedium} 96w, ${muhruSerif} 129w`}
                            sizes={"(max-width: 576px) 64px,(max-width: 768px) 96px, 129px"}
                            src={muhruSerif} alt="Mührü Şerif" />
                    </div>
                </div>
            </div>
        );
    }
}

export default HeaderTop;